import React, { useState } from "react";
import "./FilterPanel.css";
import CustomDropdown from "./CustomDropdown";

import { indianStates } from "../../data/indianStates";

const FilterPanel = ({ onApply }) => {
  // Use state keys for the state dropdown
  const states = Object.keys(indianStates);
  const courseTypes = ["Engineering", "Management", "Medical", "Arts", "Science", "Commerce"];
  
  // Local state for UI
  const [selectedState, setSelectedState] = useState("");
  const [availableDistricts, setAvailableDistricts] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [feesRange, setFeesRange] = useState("");
  const [nirfRanking, setNirfRanking] = useState("");
  const [selectedCourseType, setSelectedCourseType] = useState("");

  const handleLocationSelect = (location) => {
    let newLocations;
    if (selectedLocations.includes(location)) {
      newLocations = selectedLocations.filter((l) => l !== location);
    } else {
      newLocations = [...selectedLocations, location];
    }
    setSelectedLocations(newLocations);
  };

  const handleStateChange = (state) => {
    setSelectedState(state);
    // Update available districts based on selected state
    if (state && indianStates[state]) {
        setAvailableDistricts(indianStates[state]);
    } else {
        setAvailableDistricts([]); // or reset to empty
    }
    // Clear previously selected locations when state changes to avoid invalid districts
    setSelectedLocations([]); 
  };

  const handleFeesChange = (fees) => {
    setFeesRange(fees);
  };

  const handleNirfRankingChange = (ranking) => {
    setNirfRanking(ranking);
  };

  const handleCourseTypeChange = (courseType) => {
    setSelectedCourseType(courseType);
  };

  const clearAllFilters = () => {
    setSelectedState("");
    setAvailableDistricts([]);
    setSelectedLocations([]);
    setFeesRange("");
    setNirfRanking("");
    setSelectedCourseType("");
  };

  const handleApply = () => {
    if (onApply) {
      onApply({
        state: selectedState,
        districts: selectedLocations,
        fees: feesRange,
        ranking: nirfRanking,
        courseType: selectedCourseType
      });
    }
  };

  return (
    <div className="filter-main">
      <div className="filter-header">
        <h3>Filters</h3>
        <button className="remove-btn" onClick={clearAllFilters}>
          REMOVE ALL
        </button>
      </div>

      {/* State Filter */}
      <div className="filter-block">
        <label>State</label>
        <CustomDropdown
          options={states}
          value={selectedState}
          onChange={handleStateChange}
          placeholder="Select State"
        />
      </div>

      {/* Locations Filter */}
      <div className="filter-block">
        <label>District (Location)</label>
        <CustomDropdown
          options={availableDistricts.length > 0 ? availableDistricts : ["Select a State first"]}
          value="" // Always empty to allow multiple selections via chips
          onChange={handleLocationSelect}
          placeholder={availableDistricts.length > 0 ? "Select District" : "Select State First"}
          disabled={availableDistricts.length === 0}
        />

        <div className="chips-wrapper">
          {selectedLocations.map((location) => (
            <div
              className="chip chip-blue"
              key={location}
            >
              {location}
              <span onClick={() => handleLocationSelect(location)}>✕</span>
            </div>
          ))}
        </div>
      </div>

      {/* Fees */}
      <div className="filter-block">
        <label>Total Fees</label>
        <CustomDropdown
          options={[
            "Below ₹1,00,000", 
            "₹1,00,000 - ₹3,00,000", 
            "₹3,00,000 - ₹10,00,000",
            "₹10,00,000+"
          ]}
          value={feesRange}
          onChange={handleFeesChange}
          placeholder="Select fees"
        />
      </div>

      {/* NIRF Ranking */}
      <div className="filter-block">
        <label>NIRF Ranking</label>
        <CustomDropdown
          options={["1-10", "11-50", "51-100", "100+"]}
          value={nirfRanking}
          onChange={handleNirfRankingChange}
          placeholder="Select ranking"
        />
      </div>

      {/* Course Type */}
      <div className="filter-block">
        <label>Course Type</label>
        <CustomDropdown
          options={courseTypes}
          value={selectedCourseType}
          onChange={handleCourseTypeChange}
          placeholder="Select course type"
        />
      </div>
          <div className="apply-filter-parent">

      <button className="apply-filters-btn" onClick={handleApply}>
        APPLY FILTERS
      </button>
          </div>
    </div>
  );
};

export default FilterPanel;
